import axios from 'axios';

const CryptoJS = require('crypto-js');

const API_URL = process.env.REACT_APP_BASEURL;
let cipher = '';
const encryptKey = async () => {
    await axios.get(`${API_URL}Home/GetDate`).then((response) => {
        const apiKey = response.data;
        cipher = CryptoJS.AES.encrypt(apiKey.toString(), CryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_API_SECRET_KEY}`), {
            keySize: 128 / 8,
            iv: CryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_API_SECRET_KEY}`),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }).toString();
    });
    axios.defaults.headers.common = { key: `${cipher}` };
};
const getData = async (action) => {
    await encryptKey();
    const result = await axios.get(API_URL + action);
    return result;
};
const postData = async (action, data) => {
    await encryptKey();
    const result = await axios.post(API_URL + action, data);
    return result;
};
const putData = async (action, data) => {
    await encryptKey();
    const result = await axios.put(API_URL + action, data);
    return result;
};
const deleteData = async (action) => {
    await encryptKey();
    const result = await axios.delete(API_URL + action);
    return result;
};

const eksportoStream = async (action, gjuha) => {
    await encryptKey();
    return fetch(`${API_URL}Services/${action}?Gjuha=${gjuha}`, {
        method: 'GET',
        headers: { key: cipher },
    });
};

// Dokumenti hapet permes ShikoUrl-se (me token HMAC) qe e ndertoi API-ja ne pergjigjen
// e TeDhenatBiznesit. S'ka me nevoje per 'id'/'nui' te papertecktuar, as per header-in 'key'
// (endpoint-i eshte perjashtuar nga skema 'Key' dhe mbrohet nga tokeni ne URL).
const shikoDokumentin = async (shikoUrl, signal, emri) => {
    let url = shikoUrl;
    if (emri) url += `${url.indexOf('?') === -1 ? '?' : '&'}emri=${encodeURIComponent(emri)}`;
    return fetch(url, {
        method: 'GET',
        signal: signal,
    });
};

// Pasqyra financiare e ATK-se vjen si skedar Excel, prandaj merret me fetch (si blob),
// jo me axios. Tokeni "atk" eshte ai qe erdhi me detajet e biznesit.
const pasqyraFinanciareATK = async (token, viti, formulari) => {
    await encryptKey();
    const query = `token=${encodeURIComponent(token)}&viti=${encodeURIComponent(viti)}&formulari=${encodeURIComponent(formulari)}`;
    return fetch(`${API_URL}Services/PasqyraFinanciareATK?${query}`, {
        method: 'GET',
        headers: { key: cipher },
    });
};

const eksportoTeGjithaBizneset = (gjuha) => eksportoStream('EksportoBizneset', gjuha);
const eksportoBiznesetShuar = (gjuha) => eksportoStream('EksportoBiznesetShuar', gjuha);
const eksportoBiznesetHuaj = (gjuha) => eksportoStream('EksportoBiznesetHuaj', gjuha);
const eksportoBiznesetFemra = (gjuha) => eksportoStream('EksportoBiznesetFemra', gjuha);

const eksportoTeGjithaBiznesetJson = (gjuha) => eksportoStream('EksportoBiznesetJson', gjuha);
const eksportoBiznesetShuarJson = (gjuha) => eksportoStream('EksportoBiznesetShuarJson', gjuha);
const eksportoBiznesetHuajJson = (gjuha) => eksportoStream('EksportoBiznesetHuajJson', gjuha);
const eksportoBiznesetFemraJson = (gjuha) => eksportoStream('EksportoBiznesetFemraJson', gjuha);

export {
    getData,
    postData,
    putData,
    deleteData,
    shikoDokumentin,
    pasqyraFinanciareATK,
    eksportoTeGjithaBizneset,
    eksportoBiznesetShuar,
    eksportoBiznesetHuaj,
    eksportoBiznesetFemra,
    eksportoTeGjithaBiznesetJson,
    eksportoBiznesetShuarJson,
    eksportoBiznesetHuajJson,
    eksportoBiznesetFemraJson,
};
